import type { LooseObject } from "~/utils/Types";

/**
 * How one image names itself. Body number is the grader-facing identity but
 * only the AUS presets carry it, and it is unpopulated at some plants — the
 * barcode is the fallback because the base projection always has it.
 *
 * The tile shows only `primary`; the viewer shows both, so the two must agree
 * on which one leads.
 */
export const resolveImageIdentity = ({
  bodyIdKey,
  idKey,
  item,
}: {
  bodyIdKey: string;
  idKey: string;
  item: LooseObject;
}) => {
  const bodyId = item[bodyIdKey];
  const barcode = item[idKey];

  return {
    bodyId:
      bodyId === undefined || bodyId === null || bodyId === ""
        ? undefined
        : String(bodyId),
    barcode: barcode === undefined || barcode === null ? "" : String(barcode),
  };
};
